const protocol = window.location.protocol + '//';
const hostname = window.location.hostname;
const origin = protocol + hostname;

export const authBaseURL = hostname.includes('dxinaz.dev')
    ? origin
    : hostname.includes('dxinaz.qa1')
    ? origin
    : hostname.includes('dxinaz.prod-dr')
    ? origin
    : hostname.includes('dxinaz.prod')
    ? origin
    : hostname.includes('dxinaz.perf1')
    ? origin
    : hostname.includes('wmsops-dev')
    ? origin
    : hostname.includes('wmsops-qa1')
    ? origin
    : hostname.includes('wmsops')
	  ? origin
    : hostname.includes('dxinaz.perf1')
    ? origin
    : hostname.includes('wmsops.dev')
    ? origin
    : hostname.includes('wmsops.qa1')
    ? origin
    : hostname.includes('wmsops.prod')
    ? origin
    : hostname.includes('wmsops.prod-dr')
    ? origin
    : origin + ':7000';

